<template>
  <div class="block-legal-container">
    <div class="content-container">
      <div
        class="expander"
        :class="{ 'expander--open': expanded }"
        @click="expanded = !expanded"
      >
        <img src="../images/utils/arrow-down.svg" alt />
      </div>
      <div
        class="legal-text-block"
        :class="{ 'legal-text-block--expanded': expanded }"
      >
        1. До 01.03.2022 года при обмене автомобиля марки Audi возрастом до 7 лет с даты первой регистрации по ПТС и обмене на новый Audi предлагается дополнительный бонус по программе Audi Family до 350 000 рублей. Размер бонуса зависит от выбранной модели Audi и суммируется к оценке стоимости вашего текущего автомобиля. Акция распространяется также на S и RS модели. Предоставление денежного преимущества в виде снижения цены приобретаемого автомобиля на сумму, которая устанавливается в зависимости от выбранной модели: Audi А3 – до 60 000 рублей, Audi A4 — до 120 000 рублей, Audi A5 — до 110 000 рублей, Audi A6 — до 150 000 рублей, Audi A7 Sportback — до 150 000 рублей, Audi A8 — до 350 000 рублей, Audi Q3 — до 100 000 рублей, Audi Q5 — до 180 000 рублей, Audi Q7 — до 130 000 рублей, Audi Q8 — до 130 000 рублей, e-tron – до 110 000 рублей. Денежный эквивалент бонуса не выдается. Предложение не является публичной офертой
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "block-legal",
  components: {},
  directives: {},
  mixins: [],
  props: [""],
  data() {
    return {
      expanded: false,
    };
  },
  methods: {
    getLastDayOfMonth(year, month) {
      let date = new Date(year, month + 1, 0);
      return date.getDate();
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles/constants.scss";

.block-legal-container {
  font-size: 15px;
  font-weight: 300;
  line-height: 18px;
  width: 100%;
  padding: 26px 20px 41px;
  background-color: #fff;
  color: $legal_text;
  position: relative;
}

.content-container {
  max-width: 1110px;
  margin: 0 auto;
}

.legal-text-block {
  margin-bottom: 15px;
  max-height: 70px;
  overflow-y: hidden;
  transition: max-height 0.3s ease;

  &--expanded {
    max-height: 100%;
    overflow-y: initial;
  }
}

.phone {
  white-space: nowrap;
  cursor: pointer;
}

.expander {
  cursor: pointer;
  position: absolute;
  bottom: 32px;
  left: 50%;
  transform: translateX(-50%) rotate(180deg);
  z-index: 2;

  &--open {
    transform: translateX(-50%) rotate(0);
  }
}
</style>
